/* eslint-disable indent */
import i18n from 'i18next';
import i18nextHttpBackend from 'i18next-http-backend';
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";

// const resources = {
//   el: {
//     translatsion: translationEl
//   },
//   en: {
i18n
  //     translation: translationEn
  //   }
  // };

  .use(i18nextHttpBackend)
  .init({
    debug: false,
    lng: 'el',
    fallbackLng: 'el',
    // backend: {
    //   backends: [
    //     LocalStorageBackend,
    //     HttpBackend
    //   ],
    //   backendOptions: [{
    //     expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days
    //   }, {
    //     loadPath: `${process.env.REACT_APP_BACKEND_URL}/translations/{{lng}}`, // The HTTP request to your translation file
    //   }]
    // }

    backend: {
      backends: [
        LocalStorageBackend,
        HttpBackend
      ],
      expirationTime: 7 * 24 * 60 * 60 * 1000, // 7 days
      // loadPath: `http://localhost:5000/translations/{{lng}}`, // The HTTP request to your translation file
      loadPath: `${process.env.REACT_APP_BACKEND_URL}/translations/{{lng}}`, // The HTTP request to your translation file
    },

  });

export default i18n;